import CekKeluarMasukTradoEditorMain from "../../features/cek-keluar-masuk/cek-keluar-masuk-trado/cek-keluar-masuk-trado-editor/component/CekKeluarMasukTradoEditorMain";

const CekKeluarMasukTradoEditorPage = () => {
  return <CekKeluarMasukTradoEditorMain />;
};

export default CekKeluarMasukTradoEditorPage;
